// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3LVpt","itemTitle":"ClientEmergencyInfo_itemTitle__22gWY","itemText":"ClientEmergencyInfo_itemText__3_LcZ"};